<template>
  <div className="animated">
    <div class="animated fadeIn">
      <b-row class="my-2">
        <b-col>
          <h1 class="text-uppercase font-weight-bold">{{ $route.meta.label }} {{ $route.params.id }}</h1>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form @submit="onSubmit">
            <b-row align-v="start">
              <b-col>
                <b-form-group
                  id="fieldset-horizontal"
                  content-cols-lg="9"
                  label-align-sm="right"
                  label="Ingrese planta"
                  label-for="input-horizontal"
                >
                  <b-form-select
                    size="sm"
                    id="input-horizontal"
                    :options="plantOptions"
                    v-model="form.plant"
                  ></b-form-select>
                </b-form-group>
                <b-form-group
                  id="fieldset-horizontal"
                  content-cols-lg="9"
                  label-align-sm="right"
                  label="Ingrese línea"
                  label-for="input-horizontal"
                >
                  <template #description>
                    <div v-html="getCapacityDescriptionText"></div>
                  </template>
                  <b-form-select
                    size="sm"
                    id="input-horizontal"
                    :options="lineOptions"
                    v-model="form.line"
                  ></b-form-select>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group
                  id="fieldset-horizontal"
                  content-cols-lg="9"
                  label-align-sm="right"
                  label="Ingrese turno"
                  label-for="input-horizontal"
                >
                  <b-form-select size="sm" id="input-horizontal" :options="shiftOptions"></b-form-select>
                </b-form-group>
                <b-form-group
                  id="fieldset-horizontal"
                  content-cols-lg="9"
                  label-align-sm="right"
                  label="Ingrese fecha del proceso"
                  label-for="input-horizontal"
                >
                  <b-form-datepicker
                    id="input-1"
                    size="sm"
                    v-model="form.date"
                    :state="$v.form.date.$dirty ? !$v.form.date.$error : null"
                  ></b-form-datepicker>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <op-list :items="opItems" title="Listado de órdenes de pedido"></op-list>
              </b-col>
            </b-row>
            <b-row v-if="ready">
              <b-col class="pr-1" :lg="7 - opItems.length" :md="7 - opItems.length">
                <pallet-list @update="handleUpdateItems" :items="items"></pallet-list>
              </b-col>
              <b-col class="px-1" :lg="3 - opItems.length" :md="3 - opItems.length">
                <qc-list :items="items"></qc-list>
              </b-col>
              <b-col class="px-1" lg="2" md="2">
                <template v-for="op in opItems">
                  <selected-op
                    :key="op.id"
                    :capacity="capacity"
                    :op-total="op.remaining_kilograms"
                    :op="op"
                    :items="items"
                    :title="`Op #${op.id}`"
                    @update-selected="handleSelectItem"
                  ></selected-op>
                </template>
              </b-col>
              <b-col class="pl-1" lg="1" md="1">
                <rest-list :items="items"></rest-list>
              </b-col>
            </b-row>
            <!-- Boton de guardar -->
            <b-button type="submit" variant="primary" class="float-right" :disabled="$v.form.$invalid || loading">
              Guardar
            </b-button>
          </b-form>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import PalletList from "./PalletList.vue";
import SelectedOp from "./SelectedOp.vue";
import OpList from "./OpList.vue";
import QcList from "./QcList.vue";
import RestList from "./RestList.vue";
import applyMarketFilters from "./applyMarketFilters";
// import stock.json
import stock from "./stock.json";

export default {
  name: "CreateProductionPlan",
  components: {
    PalletList,
    RestList,
    SelectedOp,
    OpList,
    QcList
  },
  data() {
    return {
      loading: false,
      ready: false,
      form: {
        date: null,
        purchase_order: null,
        shift: null,
        plant: null,
        line: null
      },
      opItems: [],
      selectedItems: [],
      items: [],
      capacity: 0,
      opTotal: 2000,
      plantOptions: [],
      shiftOptions: [],
      workerOptions: [],
      lineOptions: []
    };
  },
  validations: {
    form: {
      date: {
        required
      }
    }
  },
  mounted() {
    this.form.purchase_order = this.$route.params.purchaseOrderId;
    this.getPlantsAndShifts();
    this.getOp(this.$route.params.purchaseOrderId).then(() => {
      this.getData().then((data) => {
        let filters = {};
        const op = this.opItems[0];
        // "accepted_certs", "accepted_varieties", "accepted_classifications"
        filters["accepted_certs"] = op.plan.market.accepted_certs;
        filters["accepted_varieties"] = op.plan.market.s_accepted_varieties;
        filters["accepted_classifications"] = op.plan.market.accepted_classifications;
        this.items = applyMarketFilters(filters, data, op.container).then((data) => {
          this.items = data;
          this.toggleOverlay();
          this.$nextTick(() => {
            this.ready = true;
          });
        });
      });
    });
  },
  watch: {
    "form.plant": function (val) {
      if (val) {
        this.getLineOptions(val);
      }
    },
    "form.line": function (val) {
      if (val) {
        this.getCapacity(val);
      }
    }
  },
  computed: {
    getCapacityDescriptionText() {
      if (this.capacity > 0) {
        const html = `<span class="text-dark">Capacidad de la línea: <strong>${this.capacity}</strong> kg/h</span>`;
        return html;
      } else {
        return "No se ha encontrado capacidad para la line y el formato seleccionado";
      }
    }
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.saveData();
      }
    },
    toggleOverlay() {
      this.$store.dispatch("toggleOverlay");
    },
    handleSelectItem(payload) {
      this.selectedItems = payload.items;
      // update opItems
      let newOp = this.opItems.find((op) => op.id === payload.op);
      newOp["selected_boxes"] = payload.boxes;
      newOp["remaining_boxes"] = newOp["quantity"] - newOp["completed_boxes"] - payload.boxes;
    },
    async saveData() {
      this.loading = true;
      try {
        await this.$axios.post("/api/v1/production_plan/", this.form);
        this.$swal({
          title: "Plan de producción creado",
          text: "El plan de producción ha sido creado correctamente",
          type: "success",
          confirmButtonText: "Aceptar"
        });
        this.$router.push({ name: "procesos-listado-orden-de-pedido" });
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    handleUpdateItems(items) {
      this.items = items;
    },
    async getOp(id) {
      try {
        const response = await this.$axios.get(
          `/api/v1/purchase_order/${id}/?fields=id,delivery_date,kilograms,progress,container,quantity,completed_boxes,remaining_boxes,plan&expand=container,plan.market`
        );
        let item = response.data;
        item["selected_kilograms"] = 0;
        item["remaining_kilograms"] = parseFloat(item["kilograms"]) - parseFloat(item["completed_kilograms"] | 0);
        this.opItems.push(item);
      } catch (error) {
        console.log(error);
      }
    },
    async getData() {
      this.toggleOverlay();
      let items = [];
      try {
        const response = await this.$axios.get("/api/v1/content/cached_stock/?product_id=14");
        items = response.data;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
      return items;
    },
    async getPlantsAndShifts() {
      try {
        const response = await this.$axios.get("/production/get_client_plants/");
        this.plantOptions = response.data.plants;
        this.shiftOptions = response.data.shifts;
        this.workerOptions = response.data.workers;
      } catch (error) {
        console.log(error);
      }
    },
    getLineOptions(plant) {
      this.$axios.get(`/production/get_plant_process_rooms/${plant.id}`).then((response) => {
        this.lineOptions = response.data.process_rooms;
      });
    },
    getCapacity(line_id) {
      this.$axios
        .get(`/api/v1/capacity/get_capacity/?process_room=${line_id}&container=${this.opItems[0].container.id}`)
        .then((response) => {
          const capacity = response.data.capacity;
          if (capacity) {
            this.capacity = capacity;
          } else {
            this.capacity = 0;
          }
        });
    }
  }
};
</script>

<style scoped>
.reduce-padding {
  padding-left: 8px !important;
  padding-right: 8px !important;
}
</style>
